import type { RefObject } from 'react';
import type { GridApi } from '@mui/x-data-grid-premium';
import { useGridStatePersistence } from '@/lib/useGridStatePersistence';

type PersistenceOptions = Parameters<typeof useGridStatePersistence>[4];

/**
 * useGridStatePersistence for a grid that renders conditionally — behind a loading spinner, a
 * fetched-data guard or an empty-state branch. Mount it right AFTER <DataGridPremium> in the same
 * conditional JSX: a hook called by the parent runs its mount-time effects while the spinner is
 * up, when apiRef.current is still null, and silently does nothing. Mounted with the grid, its
 * effects run after the grid's, when the api exists, and it restores the layout every time the
 * grid mounts again.
 */
export function GridStatePersistence({ apiRef, module, entity, variant, options }: {
  apiRef: RefObject<GridApi | null>;
  module: string;
  entity: string;
  variant?: string;
  options?: PersistenceOptions;
}) {
  useGridStatePersistence(apiRef, module, entity, variant, options);
  return null;
}
